<div class="role-edit-dialog">
  <div class="dialog-header">
    <div>
      <div class="header-text">
        <h2>{{ data.role.name }}</h2>
        @if (data.role.description) {
        <p class="role-description">
          {{ data.role.description }}
        </p>
        }
      </div>
    </div>
    <button mat-icon-button (click)="onClose()" class="close-button" cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    @if (isProtectedRole()) {
    <div class="protected-warning">
      <mat-icon>info</mat-icon>
      <span>This is a protected system role. Permissions cannot be modified.</span>
    </div>
    }

    @if (isLoading) {
    <div class="loading-state">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
    } @else {
    <div class="permissions-form">
      @for (group of permissionGroups; track group.category) {
      <div class="permission-category">
        <h3 class="category-title">{{ group.category }}</h3>
        <div class="permission-list">
          @for (permission of group.permissions; track permission.id) {
          <div class="permission-item">
            <div class="permission-info">
              <span class="permission-label">{{ permission.name }}</span>
              <span class="permission-description">{{
                permission.description
              }}</span>
            </div>
            <mat-slide-toggle
              [checked]="isPermissionEnabled(permission)"
              [disabled]="isProtectedRole() || isSaving"
              (change)="onTogglePermission(permission, $event.checked)"
              class="toggle-success"
              [hideIcon]="true"
            ></mat-slide-toggle>
          </div>
          }
        </div>
      </div>
      }
    </div>
    }
  </mat-dialog-content>
</div>
